import styled from "styled-components";

const Wrapper = styled.div`
  cursor: pointer;
  padding: 15px 21px;
  max-width: 310px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 4px #0000000a;
  border: 1px solid #0000001a;
  border-radius: 6px;
  opacity: 1;

  @media only screen and (max-width: 768px) {
  }
`;

const Title = styled.div`
  font: bold 18px "Bebas Neue Pro";
  letter-spacing: 0.47px;
  color: #000000de;
  text-transform: uppercase;
  opacity: 1;
`;

const Text = styled.div`
  text-align: left;
  font: normal 12px Roboto Regular;
  letter-spacing: 0px;
  color: #000000de;
  opacity: 1;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

interface Props {
  title: string;
  text: string;
  handleClick: () => void;
}

export const QuickLink = ({ title, text, handleClick }: Props) => {
  return (
    <Wrapper onClick={handleClick}>
      <Title>{title}</Title>
      <Text>{text}</Text>
    </Wrapper>
  );
};
